import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConstantsProject } from '@web/project/shared/constants.class';

@Component({
  selector: 'web-section-title',
  templateUrl: './section-title.component.html',
  styleUrls: ['./section-title.component.scss'],
})
export class SectionTitleComponent implements OnInit {

  constructor(translate: TranslateService, public router: Router) { }

  @Input() title: string;
  @Input() subtitle: string;
  @Input() private: boolean;
  @Input() back: boolean;
  @Input() backUrl: string;
  @Input() icon: string;
  @Input() svgIcon: string;
  @Input() type: number;

  public colorSection: string; // Color de la sección según el tipo de contenido (no se usa de momento)

  ngOnInit() {
    switch (this.type) {
      case ConstantsProject.CONTENTS_OBSERVATORIES_PORTALS:
        this.colorSection = 'var(--color-observatory)';
        break;
      default:
        this.colorSection = 'var(--color-secondary)';
        break;
    }
  }

  goBack() {
    if (this.backUrl) {
      this.router.navigateByUrl(this.backUrl);
    }
  }
}
